<template>
  <div class="row h-100">
    <div class="col-12" v-for="(card, index) in cards" :key="index">
      <div class="card card-small">
        <div class="card-body position-relative">
          <div
            v-if="card.showTooltip"
            class="info"
            data-bs-toggle="tooltip"
            data-bs-placement="right"
            title="The value calculated based on schedule for this month"
          >
            i
          </div>
          <div class="widget-content">
            <div class="image">
              <img :src="require(`@/assets/images/icon/${card.img}.png`)" />
            </div>
            <div>
              <h4 class="title" v-html="titleHTML(card)"></h4>
              <span class="subtitle">{{ card.subtitle }}</span>
            </div>
          </div>
        </div>
        <div v-if="card.value" class="card-footer">
          <span @click="openLightModal">See All Streetlights >></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["cards"],
  data() {
    return {
      // cards: [
      //   {
      //     img: "energy",
      //     title: "856.68 kWh",
      //     subtitle: "This Week\nTotal Energy",
      //     showTooltip: true,
      //   },
      //   {
      //     img: "co2",
      //     title: "1,998.80 Kg",
      //     subtitle: "Co2 Emissions\nReduction",
      //   },
      //   {
      //     img: "light",
      //     value: 87,
      //     title: "{value} out of 121",
      //     subtitle: "Last Hour\nOperational Light(s)",
      //   },
      //   {
      //     img: "light",
      //     title: "50%",
      //     subtitle: "Last Hour\nBrightness Level",
      //   },
      // ],
    };
  },
  methods: {
    openLightModal() {
      this.$emit("open-light-modal");
    },
    titleHTML(card) {
      if (!card) return;
      if (!card.title.includes("{value}")) {
        return `<strong>${card.title}</strong>`;
      }
      return card.title.replace(
        "{value}",
        `<strong>${card.value}</strong>` || 0
      );
    },
  },
};
</script>